// DEPENDENCIES
import React from 'react';
import PropTypes from 'prop-types';
import { Link } from 'react-router-dom';
// ICONS
import { AiOutlineLoading } from 'react-icons/ai';

const Button = (props) => {
  const {
    text,
    size,
    type,
    style,
    to,
    onClick,
    className,
    isTextUppercase,
    isBadge,
    isLoading,
    isDisabled,
    iconLeft,
    iconRight
  } = props;

  const sizes = {
    lg: '--lg',
    md: '--md',
    sm: '--sm',
    xs: '--xs',
    xxs: '--xxs',
    xxxs: '--xxxs',
    icon: '--icon'
  };

  const content = (
    <>
      {iconLeft}
      {isLoading ? (
        <AiOutlineLoading className="loading-indicator rotating mr-0" size={20} />
      ) : (
        text
      )}
      {iconRight}
    </>
  );

  const commonProps = {
    style,
    className: `button${size ? sizes[size] : ''} ${className || ''} ${isTextUppercase ? 'uppercase' : ''} ${isBadge ? 'badge' : ''}`,
    disabled: isDisabled || isLoading
  };

  if (to) {
    return (
      <Link to={to} {...commonProps} onClick={onClick}>
        {content}
      </Link>
    );
  }

  return (
    <button type={type} onClick={onClick} {...commonProps}>
      {content}
    </button>
  );
};

Button.propTypes = {
  text: PropTypes.string,
  size: PropTypes.string,
  type: PropTypes.string,
  style: PropTypes.object,
  to: PropTypes.string,
  onClick: PropTypes.func,
  className: PropTypes.string,
  isTextUppercase: PropTypes.bool,
  isBadge: PropTypes.bool,
  isLoading: PropTypes.bool,
  isDisabled: PropTypes.bool,
  iconLeft: PropTypes.element,
  iconRight: PropTypes.element
};

Button.defaultProps = {
  text: '',
  size: '',
  type: 'button',
  style: {},
  to: null,
  onClick: () => { },
  className: '',
  isTextUppercase: false,
  isBadge: false,
  isLoading: false,
  isDisabled: false,
  iconLeft: null,
  iconRight: null
};

export default Button;